import { ChevronRight } from 'lucide-react';
import Avatar from '../Avatar';

export default function VoterRow({ voter, isYou = false, onPress, layout = 'default' }) {
  const label = isYou ? 'You' : voter.display_name || 'User';
  const isModal = layout === 'modal';

  const avatar = (
    <Avatar
      displayName={voter.display_name}
      profilePhotoUrl={voter.profile_photo_url}
      size="xs"
      className={isModal ? '!h-[34px] !w-[34px]' : ''}
    />
  );

  const nameEl = (
    <span
      className={`min-w-0 flex-1 truncate text-left ${isModal ? 'text-meta font-semibold text-ink' : 'text-sm font-medium text-ink'}`}
    >
      {label}
    </span>
  );

  const content = (
    <>
      {avatar}
      {nameEl}
      {onPress && <ChevronRight size={16} className="shrink-0 text-ink/40" aria-hidden />}
    </>
  );

  if (!onPress) {
    return <div className="flex items-center gap-3 px-1 py-2">{content}</div>;
  }

  return (
    <button
      type="button"
      onClick={() => onPress(voter)}
      className="flex w-full items-center gap-3 rounded-xl px-1 py-2 text-left transition-colors hover:bg-white/10"
    >
      {content}
    </button>
  );
}

export function sortVotersYouFirst(voters = [], viewerId) {
  return [...voters].sort((a, b) => {
    if (a.id === viewerId) return -1;
    if (b.id === viewerId) return 1;
    return (a.display_name || '').localeCompare(b.display_name || '');
  });
}
